import AOS from "aos";
import "aos/dist/aos.css";

import SiteNavbar from "./components/SiteNavbar";
import Header from "./components/Header";
import AboutUs from "./components/AboutUs";
import Projects from "./components/Projects";
import Services from "./components/Services";
import Footer from "./components/Footer";
import CallToAction from "./components/CallToAction";
import ContactUs from "./components/ContactUs";

import siteData from "./data/SiteData.json";
import aboutUsData from "./data/AboutUs.json";
import operatingHours from "./data/OperatingHours.json";

import "./App.css";
import "./fonts.css";
import { useEffect } from "react";
import ComingSoon from "./components/ComingSoon";

function App() {
  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 1000,
      easing: "ease-out",
    });
  }, []);

  return (
    <div>
      {/* <ComingSoon/> */}
      <SiteNavbar siteData={siteData} />
      <Header />
      <AboutUs aboutUsData={aboutUsData} />
      <Services />
      <CallToAction
        phoneNumber={siteData.phoneNumber}
        imageBackground="/images/dark-leaves.jpg"
      />
      {/* <Projects /> */}
      <ContactUs />
      <Footer
        aboutUsData={aboutUsData}
        siteData={siteData}
        operatingHours={operatingHours}
      />
    </div>
  );
}

export default App;
